import { Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import React from 'react';

import { vitrins } from 'shared/assets';
import { normalizePrepositionVSpacing, useAppSelector } from 'shared/lib';
import { sendEventChangeLocation } from 'shared/lib/sendGAEvents';

import { seoH1Selector, seoSubHeadingSelector } from 'entities/metadata';

import { UpdateUserCity } from 'features/UpdateUserCity';

import styles from './VitrinsHeader.module.scss';

export const VitrinsHeader = () => {
  const isMobile = useIsMobile();
  const headingText = useAppSelector(seoH1Selector);
  const subHeadingText = useAppSelector(seoSubHeadingSelector);

  return (
    <Space className={styles.header}>
      <Space
        className={cn('h-pt-24', { 'h-pl-16 h-pr-16': isMobile })}
        direction="vertical"
        size={isMobile ? 8 : 20}
      >
        <Typography.Heading
          level={1}
          className={styles.heading}
        >
          {normalizePrepositionVSpacing(headingText!)}
        </Typography.Heading>
        <UpdateUserCity onChangeCityClick={sendEventChangeLocation} />
        <Typography.Text
          className="h-color-D60"
          data-qa="SeoMiniText"
        >
          {subHeadingText}
        </Typography.Text>
      </Space>
      {!isMobile && (
        <img
          style={{ flex: 'none', maxWidth: '100%' }}
          src={vitrins as string}
          width={300}
          height={300}
          alt="Few coins flying near ledder"
        />
      )}
    </Space>
  );
};
